import { useCallback } from 'react'

import { fetchStatus } from '../api/status'
import { useLoad } from '../api/useLoad'

/**
 * Which build is answering, said quietly at the foot of the navigation.
 *
 * It is here because the first question about anything odd is which version somebody is actually
 * looking at, and reading that off a log on the server is answering it too late.
 *
 * **The commit hash is deliberately not here.** It was, first in full and then shortened, and neither
 * belonged: forty hex characters wrapped across two lines and pushed the navigation about, and seven
 * are a string nobody reads either — they are decoration in the one part of the screen that has to
 * stay quiet. What is running is reported by `/api/status`, which is the one place it is reported and
 * where anything that needs it looks.
 *
 * Nothing here may cost anybody the frame it sits in. A service that does not answer, or one that
 * cannot say which version it is, ends in this showing nothing at all.
 */
export function Version() {
  const loadStatus = useCallback((signal: AbortSignal) => fetchStatus(signal), [])
  const { load } = useLoad(loadStatus)

  if (load.status !== 'ready' || load.value.version === '') {
    return null
  }

  return (
    <p className="nav__version">
      <span className="nav__version-name">{load.value.version}</span>
    </p>
  )
}
